<div class="page-title-area item-bg-6">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>Tools and Version Control</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Tools and Version Control</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <div class="services-details-video">
            <div class="details-image">
                <!-- Puedes agregar una imagen principal aquí si deseas -->
            </div>
            <div class="details-video">
                <!-- Video relacionado con herramientas y control de versiones puede ir aquí -->
            </div>
            <div class="text">
                <h3>Efficient Development with the Right Tools</h3>
                <p>
                    I ensure the development process is seamless by using the best tools for version control, project management, and collaboration:
                    <br><br>
                    • <strong>Version Control with Git:</strong> I use Git for managing code versions and collaborating with teams on large-scale projects.<br>
                    • <strong>GitHub for Collaboration:</strong> I rely on GitHub for repository management, pull requests, and team collaboration.<br>
                    • <strong>Project Management Tools:</strong> I use tools like Jira and Trello for managing tasks, sprints, and keeping track of project progress.<br>
                    • <strong>Docker for Containerization:</strong> I use Docker to ensure consistency across development, testing, and production environments.
                </p>
            </div>
        </div>
         <div class="bar"></div>
        <div class="services-details-overview">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="services-details-desc">
                        <h3>Streamlined Workflow with Version Control</h3>
                        <p>
                            I use modern version control and collaboration tools to streamline the development process, ensure code quality, and maintain a productive development environment:
                            <br><br>
                            <strong>My expertise includes:</strong><br>
                            • Managing repositories with Git and GitHub<br>
                            • Automating builds, tests, and deployments with CI/CD<br>
                            • Handling versioning, branching, and merges with Git workflows<br>
                            • Collaborating with teams and tracking tasks using Jira<br>
                            • Docker-based containerization for consistency across environments
                        </p>
                        <div class="features-text">
                            <h4>Why Choose My Approach?</h4>
                            <p>
                                • <strong>Expert in Version Control:</strong> I am highly skilled in managing code repositories and ensuring efficient collaboration.<br>
                                • <strong>Modern CI/CD Pipelines:</strong> I implement CI/CD pipelines to automate testing, deployment, and build processes.<br>
                                • <strong>Streamlined Project Management:</strong> I use tools like Jira and Trello to ensure smooth and efficient project management.<br>
                                • <strong>Full Workflow Integration:</strong> I ensure all tools work together seamlessly for a consistent and efficient development lifecycle.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="services-details-image">
                        <img src="assets/img/services-details/GITHUB.webp" alt="Version Control Image">
                    </div>
                </div>
            </div>
        </div>

        <div class="services-details-overview">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="services-details-image">
                        <img src="assets/img/services-details/CI.jpeg" alt="Tools Image">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>